module.exports = "/_next/static/images/findus-monotone-5ac7febc20b4ab85b77c0e63008f2a39.svg";